var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.25C0 0.558594 0.638393 0 1.42857 0H18.5714C19.3616 0 20 0.558594 20 1.25C20 1.94141 19.3616 2.5 18.5714 2.5H1.42857C0.638393 2.5 0 1.94141 0 1.25ZM0 7.5C0 6.80859 0.638393 6.25 1.42857 6.25H18.5714C19.3616 6.25 20 6.80859 20 7.5C20 8.19141 19.3616 8.75 18.5714 8.75H1.42857C0.638393 8.75 0 8.19141 0 7.5ZM20 13.75C20 14.4414 19.3616 15 18.5714 15H1.42857C0.638393 15 0 14.4414 0 13.75C0 13.0586 0.638393 12.5 1.42857 12.5H18.5714C19.3616 12.5 20 13.0586 20 13.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.fe364bcbef67a8cc1c034f678e9aa2d6.svg";
export { ForwardRef as ReactComponent };